module.exports = __webpack_public_path__ + "static/media/tiktok.ec2f069c.svg";